/**
 * 是否是闽政通webview
 */
export const isMzt = () => {
    let userAgent = navigator.userAgent.toLowerCase()
    return userAgent.indexOf('mzt') > -1
}

/**
 * 是否是闽政通webview
 */
export const isCstoon = () => {
    let userAgent = navigator.userAgent.toLowerCase()
    return userAgent.indexOf('innoapp') > -1
}
/**
 * 是否是云闪付App webview
 */
export const isUnionApp = () => {
    let userAgent = navigator.userAgent
    return userAgent.indexOf('UnionPay/1.0 CloudPay') > -1
}
/**
 * 是否是支付宝 webView
 */
export const isAliPay = () => {
    let userAgent = navigator.userAgent.toLowerCase()
    return userAgent.indexOf('alipayclient') > -1
}

/**
 * 判断当前浏览器环境是否是微信浏览器
 * @returns {Boolean} 标志
 */
export const isWeixin = () => {
    let ua = navigator.userAgent.toLowerCase()
    return ua.indexOf('micromessenger') > -1
}

/**
 * 判断当前浏览器环境是微信浏览器还是微信小程序环境
 * @returns {Boolean} 标志
 */
export const isMiniprogram = () => {
    let ua = navigator.userAgent.toLowerCase()
    return ua.indexOf('mimiprogram') > -1 || window.__wxjs_environment === 'miniprogram'
}
/**
 * 判断当前浏览器环境是否是chorme
 * @returns {Boolean} 标志
 */
export const isChrome = () => {
    let ua = navigator.userAgent.toLowerCase()
    return ua.indexOf('chrome') > -1
}
/**
 * 判断当前手机环境是否是IOS
 * @returns {Boolean} 标志
 */
export const isIOS = () => {
    let ua = navigator.userAgent
    return !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
}

/**
 * 判断浏览器环境
 * @returns
 */
export const appEnv = () => {
    if (isAliPay()) {
        return {
            payChannel: 'alipayh5',
            appEnv: 'alipay',
            appEnvText: 'H5'
        }
    } else if (isUnionApp()) {
        return {
            payChannel: 'unionscanpay',
            appEnv: 'unionscanpay',
            appEnvText: 'H5'
        }
    } else if (isMiniprogram()) {
        return {
            payChannel: 'wxpayxcx',
            appEnv: 'miniprogram',
            appEnvText: '小程序'
        }
    } else if (isWeixin()) {
        return {
            payChannel: 'wxpayh5',
            appEnv: 'wxpay',
            appEnvText: 'H5'
        }
    } else if (isCstoon()) {
        return {
            payChannel: 'taironge',
            appEnv: 'taironge',
            appEnvText: 'H5'
        }
    } else if (isChrome()) {
        return {
            payChannel: 'chrome',
            appEnv: 'chrome',
            appEnvText: 'H5'
        }
    } else {
        return {
            payChannel: 'other',
            appEnv: 'other',
            appEnvText: 'H5'
        }
    }
}



/**
 * 计算支付频道
 * @param {Object} appEnv 支付环境
 * @param {String} payType 支付方式
 * @returns
 */
export const calcPayChannel = (appEnv, payType) => {
    if (appEnv.appEnv == 'miniprogram') {
        return payType == 2 ? 'wxpayxcx' : payType == 4 ? 'rmbpayxcx' : 'walletpayxcx'
    } else if (appEnv.appEnv == 'wxpay') {
        return payType == 2 ? 'wxpay' : payType == 4 ? 'rmbpayh5' : 'walletpaywx'
    } else if (appEnv.appEnv == 'alipay') {
        return payType == 3 ? 'alipay' : payType == 4 ? 'rmbpayh5' : 'walletpayali'
    } else {
        return payType == 2 ? 'wxpayh5' : payType == 3 ? 'alipayh5' : payType == 4 ? 'rmbpayh5' : 'walletpayapp'
    }
}
